import { KeyDict } from '@/types'
import { ref } from '@vue/composition-api'
import { COUNTRIES } from '../data/countries'
import { Loader } from '@/modules/base/classes/loaders'

export class Country {
  ageLimit: number
  code: string
  flagUrl: string
  isoCode: string
  name: string
  privacy?: boolean

  constructor (data: unknown) {
    this.ageLimit = Loader.loadNumber(data, 'ageLimit')
    this.code = Loader.loadString(data, 'code')
    this.flagUrl = Loader.loadString(data, 'flagUrl')
    this.isoCode = Loader.loadString(data, 'isoCode', '')
    this.name = Loader.loadString(data, 'name')
    this.privacy = Loader.loadBoolean(data, 'privacy', false)
  }
}

const loadCountries = () => {
  const countries: KeyDict<Country> = {}
  for (const [code, data] of Object.entries(COUNTRIES)) {
    try {
      countries[code] = new Country(data)
    } catch (error) {
      console.error(`Failed to load Country ${code}`, error)
    }
  }
  return countries
}

const useCountries = () => {
  return {
    allCountries: ref(loadCountries())
  }
}

export default useCountries
